import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import config from "../common/Config";
import Swal from "sweetalert2";
import { Box, Typography, TextField, Button, Paper, Select, MenuItem, FormControl, InputLabel, InputAdornment, TablePagination, Checkbox } from '@mui/material';
import { Iconify } from '../Minimal/src/components/iconify/iconify';
import { encryptPayload, resolveEncryptedResponse } from "../../utils/customerCrypto";
import { getCompanySettings, resolveCustomerApiEncrypt } from "../../utils/companySettingsCache";

const AmazonProduct = () => {
  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem("token");
  const activePdtRef = useRef(null);
  const searchInputRef = useRef(null);
  const [totalActiveProduct, setTotalActiveProduct] = useState(0);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [categoryValue, setCategoryValue] = useState("");
  const [searchInputValue, setSearchInputValue] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleCategoryChange = (event) => {
    const value = event.target.value;
    setCategoryValue(value);
  };

  const fetchCategoriesOptions = async () => {
    const apiCategoriesUrl = `${config.API_URL}/stock_take/getCategories`;
    try {
      const response = await fetch(apiCategoriesUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();
      const formattedOptions = data.data.category.map((item) => ({
        key: `${item.name}`,
        value: item.id,
      }));
      setCategoryOptions(formattedOptions);
    } catch (error) {
      console.error("api fail Error:", error);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
    if (activePdtRef.current && $.fn.DataTable.isDataTable(activePdtRef.current)) {
      const $table = $(activePdtRef.current);
      const api = $table.DataTable();
      api.search(value).draw();
    }
  };

  const handleChangePage = (event, newPage) => {
    if (activePdtRef.current && $.fn.DataTable.isDataTable(activePdtRef.current)) {
      const $table = $(activePdtRef.current);
      const api = $table.DataTable();
      api.page(newPage).draw('page');
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    if (activePdtRef.current && $.fn.DataTable.isDataTable(activePdtRef.current)) {
      const $table = $(activePdtRef.current);
      const api = $table.DataTable();
      api.page.len(newRowsPerPage).page(0).draw();
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = "/react/login";
      return;
    }
    fetchCategoriesOptions();
  }, [accessToken]);

  useEffect(() => {
    const $table = $(activePdtRef.current);
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }
    const table = $table.DataTable({
      pageLength: rowsPerPage,
      paging: true,
      lengthMenu: [10, 25, 50, 100],
      searching: true,
      ordering: false,
      info: true,
      responsive: true,
      autoWidth: false,
      dom: '<"top"l>rt<"clear">',
      drawCallback: function () {
        $('.dataTables_filter').hide();
        $('.dataTables_info').hide();
        $('.dataTables_paginate').hide();
        $('.dataTables_length').hide();
        
        const api = this.api();
        const currentPage = api.page();
        const currentLength = api.page.len();
        setPage(currentPage);
        setRowsPerPage(currentLength);
        setTotalActiveProduct(api.page.info().recordsTotal);
      },
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
      processing: true,
      serverSide: true,
      ajax: function (data, callback, settings) {
        (async () => {
          try {
            const companySettings = await getCompanySettings();
            const useEncrypt = resolveCustomerApiEncrypt(companySettings);
            const catNum =
              categoryValue === "" || categoryValue === null ? 0 : Number(categoryValue);
            if (useEncrypt) {
              const requestData = {
                draw: data.draw,
                start: data.start,
                length: data.length,
                searchValue:
                  data.search && data.search.value ? data.search.value : "",
                searchField: "code",
                categoryValue: catNum,
              };
              const encryptedPayload = encryptPayload(requestData);
              if (!encryptedPayload) {
                callback({
                  draw: data.draw,
                  data: [],
                  recordsTotal: 0,
                  recordsFiltered: 0,
                });
                return;
              }
              const fd = new FormData();
              fd.append("encrypted_payload", encryptedPayload);
              const res = await fetch(`${config.API_URL}/products/getactive_product`, {
                method: "POST",
                headers: { authorization: `Bearer ${token}` },
                body: fd,
              });
              const json = await res.json();
              const dec = resolveEncryptedResponse(json);
              const resolved = dec && typeof dec === "object" ? dec : json;
              if (resolved && Array.isArray(resolved.data)) {
                setTotalActiveProduct(
                  resolved.recordsTotal || resolved.recordsFiltered || 0
                );
              }
              callback(resolved);
            } else {
              $.ajax({
                url: `${config.API_URL}/products/getactive_product`,
                type: "POST",
                headers: {
                  authorization: `Bearer ${token}`,
                },
                data: $.extend({}, data, { categoryValue: catNum }),
                success: function (json) {
                  if (json && json.data && Array.isArray(json.data)) {
                    setTotalActiveProduct(
                      json.recordsTotal || json.recordsFiltered || 0
                    );
                  }
                  callback(json);
                },
                error: function () {
                  callback({
                    draw: data.draw,
                    data: [],
                    recordsTotal: 0,
                    recordsFiltered: 0,
                  });
                },
              });
            }
          } catch (e) {
            callback({
              draw: data.draw,
              data: [],
              recordsTotal: 0,
              recordsFiltered: 0,
            });
          }
        })();
      },
      columns: [
        {
          data: null,
          width: "60px",
          className: "text-center",
          render: function (data, type, row) {
            return `<input type="checkbox" class="checkbox multi-select input-xs" name="val[]" value="${row.id}" style="cursor: pointer;"/>`;
          },
        },
        { 
          data: "code", 
          className: 'text-left',
          width: "120px"
        },
        {
          data: null,
          render: function (data, type, row) {
            return `<span title="${row.name}">${row.name} - ${row.size}</span>`;
          },
        },
        { 
          data: "categories", 
          width: "200px" 
        },
        {
          data: null,
          width: "160px",
          render: function (data, type, row) {
            const status = row.shopifyID === null ? 'Not Available' : 'Available';
            if (row.shopifyID === null) {
              return `<span style="display: inline-block; background-color: #FFEBEE; color: #C62828; padding: 4px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; white-space: nowrap;">${status}</span>`;
            } else {
              return `<span style="display: inline-block; background-color: #E8F5E9; color: #2E7D32; padding: 4px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; white-space: nowrap;">${status}</span>`;
            }
          },
        },
      ],
      columnDefs: [
        {
          orderable: false,
          targets: "_all",
        }
      ],
    });

    return () => {
      if ($.fn.DataTable.isDataTable($table)) {
        $table.DataTable().destroy();
      }
    };
  }, [rowsPerPage, categoryValue]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (activePdtRef.current && $.fn.DataTable.isDataTable(activePdtRef.current)) {
        const $table = $(activePdtRef.current);
        const api = $table.DataTable();
        api.search(searchInputValue).draw();
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [searchInputValue]);


  const handleProductsSubmit = async () => {
    Swal.fire({
      title: 'Processing...',
      text: 'Please wait while we process all products.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const formData = new FormData();
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${config.API_URL}/amazon/submit-products-to-amazon`,
        {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit selection");
      }

      const data = await response.json();

      Swal.close();

      if (data.success === true) {
        Swal.fire({
          title: "Success!",
          text: "Products Created successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          if (activePdtRef.current && $.fn.DataTable.isDataTable(activePdtRef.current)) {
            const $table = $(activePdtRef.current);
            $table.DataTable().ajax.reload();
          }
        });
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        title: "Error!",
        text: "Error submitting selection.",
        icon: "error",
      });
      console.error("Error submitting selection:", error);
    }
  };

  // Handle button click to submit selected products API
  const handleSelectionSubmit = async (event) => {
    event.preventDefault();
    Swal.fire({
      title: 'Processing...',
      text: 'Please wait while we process all products.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const formData = new FormData(event.target);
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    try {
      const response = await fetch(
        `${config.API_URL}/amazon/submit-products-to-amazon`,
        {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit selection");
      }

      const data = await response.json();
      
      console.log(data);
      Swal.close();

      if (data.success === true) {
        Swal.fire({
          title: "Success!",
          text: "Products processed successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          if (activePdtRef.current && $.fn.DataTable.isDataTable(activePdtRef.current)) {
            const $table = $(activePdtRef.current);
            $table.DataTable().ajax.reload();
          }
        });
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        title: "Error!",
        text: "Error submitting selection.",
        icon: "error",
      });
      console.error("Error submitting selection:", error);
    }
  };

  const dataTablesStyles = `
    .dataTables_wrapper .dataTables_filter {
      display: none !important;
    }
    .dataTables_wrapper .dataTables_info {
      display: none !important;
    }
    .dataTables_wrapper .dataTables_paginate {
      display: none !important;
    }
    #pdtCategoryTable {
      border-collapse: collapse !important;
      border-spacing: 0 !important;
    }
    #pdtCategoryTable thead th {
      padding: 12px 16px !important;
      text-align: left !important;
      vertical-align: middle !important;
      border-bottom: 1px solid rgba(145, 158, 171, 0.16) !important;
    }
    #pdtCategoryTable thead th:first-child,
    #pdtCategoryTable thead th:nth-child(2),
    #pdtCategoryTable thead th:nth-child(5) {
      text-align: center !important;
    }
    #pdtCategoryTable tbody td {
      border-bottom: 1px dashed rgba(145, 158, 171, 0.16);
      padding: 12px 16px !important;
      font-size: 14px;
      color: #637381;
      background-color: #FFFFFF;
      text-align: left !important;
      vertical-align: middle !important;
    }
    #pdtCategoryTable tbody td:first-child,
    #pdtCategoryTable tbody td:nth-child(2),
    #pdtCategoryTable tbody td:nth-child(5) {
      text-align: center !important;
    }
    #pdtCategoryTable tbody tr:nth-of-type(even) td {
      background-color: #F9FAFB;
    }
    #pdtCategoryTable tbody tr:hover td {
      background-color: rgba(0, 0, 0, 0.02);
    }
    #pdtCategoryTable tbody td input[type="checkbox"] {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
  `;

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = dataTablesStyles;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  return (
    <div>
      <Header />
      <Box
        sx={{
          py: 1.5,
          px: 2,
          backgroundColor: '#f8f9fa',
          borderBottom: '1px solid rgba(145, 158, 171, 0.16)',
        }}
      >
        <Box sx={{ maxWidth: '100%', mx: 'auto' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '14px', color: '#637381' }}>
            <Box component="a" href="#" sx={{ color: 'inherit', textDecoration: 'none' }}>
              <i className="fa fa-home"></i>
            </Box>
            <span>&gt;</span>
            <Box component="a" href="Dashboard" sx={{ color: 'inherit', textDecoration: 'none' }}>
              Master
            </Box>
            <span>&gt;</span>
            <Typography component="span" sx={{ color: '#212B36', fontWeight: 500 }}>
              Amazon Product List
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ p: 3 }}>
        <form id="picking_create" onSubmit={handleSelectionSubmit}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>Amazon Products</Typography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <Box sx={{ position: 'relative' }}>
                <input
                  ref={searchInputRef}
                  id="searchValue"
                  type="text"
                  style={{ display: 'none' }}
                />
                <TextField
                  size="small"
                  placeholder="Search products..."
                  value={searchInputValue}
                  onChange={handleSearchChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    width: { xs: '100%', sm: 300 },
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      backgroundColor: '#F4F6F8',
                      '& fieldset': {
                        borderColor: 'rgba(145, 158, 171, 0.32)',
                      },
                      '&:hover fieldset': {
                        borderColor: 'rgba(145, 158, 171, 0.48)',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#007bff',
                      },
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', alignItems: 'center' }}>
            <FormControl size="small" sx={{ minWidth: 400 }}>
              <InputLabel>Select Categories</InputLabel>
              <Select
                id="categoryId"
                value={categoryValue}
                onChange={handleCategoryChange}
                label="Select Categories"
                sx={{
                  borderRadius: '8px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(145, 158, 171, 0.32)',
                  },
                }}
              >
                <MenuItem value="">All Categories</MenuItem>
                {categoryOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.key}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500,
                px: 2,
                py: 1,
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                },
              }}
            >
              Process Product
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleProductsSubmit}
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500,
                px: 2,
                py: 1,
                ml: 'auto',
                borderColor: 'rgba(145, 158, 171, 0.32)',
                color: '#212B36',
                '&:hover': {
                  borderColor: 'rgba(145, 158, 171, 0.48)',
                  backgroundColor: 'rgba(145, 158, 171, 0.04)',
                },
              }}
            >
              Insert All Products
            </Button>
          </Box>

          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              border: '1px solid rgba(145, 158, 171, 0.16)',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                overflowX: 'auto',
                '&::-webkit-scrollbar': {
                  width: '10px',
                  height: '10px',
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: '#F4F6F8',
                  borderRadius: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#c1c1c1',
                  borderRadius: '5px',
                  border: '2px solid #F4F6F8',
                  '&:hover': {
                    backgroundColor: '#a8a8a8',
                  },
                },
                '&::-webkit-scrollbar-corner': {
                  backgroundColor: '#F4F6F8',
                },
                scrollbarWidth: 'thin',
                scrollbarColor: '#c1c1c1 #F4F6F8',
              }}
            >
              <table
                id="pdtCategoryTable"
                ref={activePdtRef}
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  borderSpacing: 0,
                }}
              >
                <thead>
                  <tr>
                    <th style={{
                      width: '60px',
                      padding: "12px 16px",
                      backgroundColor: '#F4F6F8',
                      borderBottom: '1px solid rgba(145, 158, 171, 0.16)',
                      borderTop: 'none',
                      borderLeft: 'none',
                      borderRight: 'none',
                      fontWeight: 600,
                      fontSize: '14px',
                      color: '#637381',
                      userSelect: 'none',
                      textAlign: 'center',
                      boxShadow: 'none',
                      position: 'relative',
                    }}>
                      <Checkbox
                        size="small"
                        onChange={(e) => {
                          const checkboxes = document.querySelectorAll(
                            '#pdtCategoryTable tbody input[type="checkbox"]'
                          );
                          checkboxes.forEach(
                            (checkbox) => (checkbox.checked = e.target.checked)
                          );
                        }}
                        sx={{
                          padding: '4px',
                          '& .MuiSvgIcon-root': {
                            fontSize: '18px',
                          },
                        }}
                      />
                    </th>
                    <th style={{
                      width: '120px',
                      padding: "12px 16px",
                      backgroundColor: '#F4F6F8',
                      borderBottom: '1px solid rgba(145, 158, 171, 0.16)',
                      borderTop: 'none',
                      borderLeft: 'none',
                      borderRight: 'none',
                      fontWeight: 600,
                      fontSize: '14px',
                      color: '#637381',
                      userSelect: 'none',
                      textAlign: 'center',
                      boxShadow: 'none',
                      position: 'relative',
                    }}>Code</th>
                    <th style={{
                      width: '100px',
                      padding: "12px 16px",
                      backgroundColor: '#F4F6F8',
                      borderBottom: '1px solid rgba(145, 158, 171, 0.16)',
                      borderTop: 'none',
                      borderLeft: 'none',
                      borderRight: 'none',
                      fontWeight: 600,
                      fontSize: '14px',
                      color: '#637381',
                      userSelect: 'none',
                      textAlign: 'left',
                      boxShadow: 'none',
                      position: 'relative',
                    }}>Name</th>
                    <th style={{
                      width: '250px',
                      padding: "12px 16px",
                      backgroundColor: '#F4F6F8',
                      borderBottom: '1px solid rgba(145, 158, 171, 0.16)',
                      borderTop: 'none',
                      borderLeft: 'none',
                      borderRight: 'none',
                      fontWeight: 600,
                      fontSize: '14px',
                      color: '#637381',
                      userSelect: 'none',
                      textAlign: 'left',
                      boxShadow: 'none',
                      position: 'relative',
                    }}>Category</th>
                    <th style={{
                      width: '160px',
                      padding: "12px 16px",
                      backgroundColor: '#F4F6F8',
                      borderBottom: '1px solid rgba(145, 158, 171, 0.16)',
                      borderTop: 'none',
                      borderLeft: 'none',
                      borderRight: 'none',
                      fontWeight: 600,
                      fontSize: '14px',
                      color: '#637381',
                      userSelect: 'none',
                      textAlign: 'center',
                      boxShadow: 'none',
                      position: 'relative',
                    }}>Amazon Status</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </Box>
            <TablePagination
              component="div"
              count={totalActiveProduct}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
              labelRowsPerPage="Rows per page:"
              sx={{
                borderTop: '1px solid rgba(145, 158, 171, 0.16)',
                '& .MuiTablePagination-toolbar': {
                  px: 2,
          
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexWrap: 'nowrap',
                },
                '& .MuiTablePagination-selectLabel': {
                  fontSize: '14px',
                  color: '#637381',
                  margin: 0,
                  display: 'flex',
                  alignItems: 'center',
                },
                '& .MuiTablePagination-displayedRows': {
                  fontSize: '14px',
                  color: '#637381',
                  margin: 0,
                  marginLeft: 'auto',
                },
                '& .MuiTablePagination-select': {
                  fontSize: '14px',
                  color: '#212B36',
                  marginRight: 1,
                  marginLeft: 1,
                },
                '& .MuiTablePagination-actions': {
                  marginLeft: 1,
                },
                '& .MuiIconButton-root': {
                  color: '#637381',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                  '&.Mui-disabled': {
                    color: 'rgba(0, 0, 0, 0.26)',
                  },
                },
              }}
            />
          </Paper>
        </form>
      </Box>
   
    </div>
  );
};

export default AmazonProduct;
